<template>
  <div class="sidebar"
       :class="{ 'sidebar--mobile-expanded': mobileExpanded, 'sidebar--suppress-hover': suppressHover }"
       :style="sidebarStyle"
       :data-color="backgroundColor"
       :data-image="backgroundImage"
       @click="onSidebarClick"
       @mouseleave="suppressHover = false">
    <slot name="control"></slot>
    <div class="sidebar-wrapper">
      <div class="logo d-lg-none d-block">
        <a href="#" class="simple-text logo__container d-flex justify-content-center">
          <img src="@/assets/images/logo_cleverdocs_blanc.png" alt="" height="55px" width="150px">
        </a>
      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="link.name + index"
                        :to="link.path"
                        :href="link.path"
                        @click="closeNavbar"
                        :link="link">
            <i :class="link.icon"></i>
            <p>{{link.name}}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>

      <div class="sidebar-footer sidebar-footer--full" v-if="user">
        <p class="sidebar-footer__title">
          <a href="https://cleverbsolutions.com/" target="_blank" rel="noopener">CleverDocs | {{ $t('Cloud Solution') }}</a>
        </p>
        <p class="sidebar-footer__line">{{ $t('Version') }}: {{ version }}</p>
        <p class="sidebar-footer__line">{{ $t('Date') }}: {{ time }}</p>
      </div>
      <div class="sidebar-footer sidebar-footer--compact" v-if="user">
        <p class="sidebar-footer__title">
          <a href="https://cleverbsolutions.com/" target="_blank" rel="noopener">CleverDocs</a>
        </p>
        <p class="sidebar-footer__line">V: {{ version }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import SidebarLink from './SidebarLink.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      SidebarLink
    },
    data () {
      return {
        version: process.env.VUE_APP_VERSION,
        time: '',
        timer: null,
        // Tablet/móvil: el sidebar es siempre el riel de 72px (ver CSS), sin
        // hover real, así que aquí se expande con un toque en vez de con el
        // ratón por encima (ver mecanismo en onSidebarClick/onDocumentClick).
        mobileExpanded: false,
        // Escritorio: al navegar (logo, cualquier opción del sidebar...) el
        // ratón no se mueve, así que el CSS :hover que expande el riel
        // colapsado sigue activo y el sidebar se queda expandido después de
        // navegar. Mientras esto es true, el CSS ignora el :hover aunque el
        // ratón siga físicamente encima; se desactiva en cuanto el ratón
        // sale del sidebar (ver @mouseleave), momento en el que el :hover
        // vuelve a funcionar con normalidad.
        suppressHover: false
      }
    },
    props: {
      backgroundColor: {
        type: String,
        default: 'white',
        validator: (value) => {
          let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black','white']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundImage: {
        type: String
        // default: require('@/assets/images/sidebar-3.jpg')
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide () {
      return {
        autoClose: this.autoClose
      }
    },
    computed: {
      ...mapGetters({
        user: 'login/user'
      }),
      sidebarStyle () {
        return {
          backgroundImage: `url(${this.backgroundImage})`
        }
      }
    },
    watch: {
      // Cubre tanto la navegación por el sidebar como por el logotipo (y
      // cualquier otra navegación programática): en cuanto cambia la ruta,
      // se corta el efecto del :hover hasta que el ratón salga y vuelva a
      // entrar.
      '$route' () {
        this.suppressHover = true
        this.mobileExpanded = false
      }
    },
    mounted () {
      this.getNow()
      this.timer = setInterval(this.getNow, 1000)
      document.addEventListener('click', this.onDocumentClick, true)
    },
    beforeDestroy () {
      clearInterval(this.timer)
      document.removeEventListener('click', this.onDocumentClick, true)
    },
    methods: {
      getNow () {
        const current = new Date()
        const yr = current.getFullYear()
        const mnt = current.getMonth() + 1 < 9 ? '0' + (current.getMonth() + 1) : current.getMonth() + 1
        const day = current.getDate() < 9 ? '0' + current.getDate() : current.getDate()
        const date = day + '/' + mnt + '/' + yr
        const h = current.getHours() <= 9 ? '0' + current.getHours() : current.getHours()
        const m = current.getMinutes() <= 9 ? '0' + current.getMinutes() : current.getMinutes()
        const s = current.getSeconds() <= 9 ? '0' + current.getSeconds() : current.getSeconds()
        this.time = date + ' ' + h + ':' + m + ':' + s
      },
      // Tablet/móvil: un toque en zona vacía del sidebar (no en un botón o
      // enlace) alterna el estado expandido; un toque en una opción real lo
      // cierra (además de dejar que la navegación/acción siga su curso).
      onSidebarClick (event) {
        if (window.innerWidth > 991.98) return
        const isOption = event.target.closest('a, button, .sidebar-control')
        if (isOption) {
          this.mobileExpanded = false
          return
        }
        this.mobileExpanded = !this.mobileExpanded
      },
      // Un toque en cualquier otra zona de la vista (fuera del sidebar) lo
      // cierra. Los toques dentro del sidebar ya los gestiona
      // onSidebarClick, así que aquí se ignoran para no pisarle el toggle.
      onDocumentClick (event) {
        if (!this.mobileExpanded) return
        if (this.$el.contains(event.target)) return
        this.mobileExpanded = false
      }
    }
  }

</script>
<style>
  /* ---------- Base: sidebar claro estilo OneDrive ---------- */
  .sidebar .sidebar-wrapper {
    display: flex;
    flex-direction: column;
    background: #f7f7f8;
    height: 100%;
    max-height: 100vh;
    overflow: hidden;
    padding-top: 0;
  }
  .sidebar,
  body > .navbar-collapse {
    box-shadow: none !important;
  }
  /* El template fija top:56px y height:100vh a la vez en .sidebar, así que
     su caja se sale 56px por debajo de la ventana (justo donde se perdía
     el pie de página). Se corrige para que quepa exactamente. */
  html body .sidebar {
    height: calc(100vh - 30px) !important;
    /* El navbar y el sidebar comparten z-index:99 en la plantilla base; con
       eso empataban y el navbar ganaba el desempate, tapando el botón de
       colapsar cuando se subió a la altura del logo (que vive dentro del
       navbar). Se sube el sidebar un peldaño para que el botón sea clicable. */
    z-index: 100 !important;
  }
  /* El template trae "overflow: auto" comentado en .sidebar-wrapper, así
     que cuando el contenido no cabe (p.ej. el pie con fecha/hora) queda
     cortado sin poder verse. Aquí solo la lista de opciones hace scroll;
     el pie (footer) se queda siempre fijo abajo y visible. */
  .sidebar .nav-main__links {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    text-align: left;
  }
  .navbar {
    position: fixed !important;
    width: 100%;
    z-index: 99;
    background-color: #f7f7f8 !important;
    box-shadow: none !important;
    border-bottom: none !important;
  }
  /* El padding lateral del navbar solo se quita en escritorio (para pegar
     el logo al borde izquierdo); en tablet/móvil se mantiene, pero a 15px
     (el propio template lo sube a 30px en su media query de mobile). */
  @media (min-width: 992px) {
    .navbar {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    /* La plantilla base asume un navbar de 56px y coloca el sidebar justo
       debajo (top:56px), pero nuestro navbar de escritorio mide 72px (logo
       de 55px + 15px de margen). Antes esa franja de 16px quedaba oculta
       porque el navbar ganaba el empate de z-index con el sidebar; al subir
       el sidebar por encima para que el botón de colapsar llegue a la
       altura del logo, ese hueco pasó a recortar el propio logo. Se corrige
       el origen del problema: que el sidebar empiece donde de verdad acaba
       el navbar. */
    html body .sidebar {
      top: 72px !important;
      /* Bajar el "top" 16px sin tocar la altura empujaba el borde inferior
         del sidebar (y con él, el pie con la info de versión/compañía) 16px
         más cerca del borde de la ventana. Se resta esos mismos 16px a la
         altura para que el pie quede exactamente donde estaba antes. */
      height: calc(100vh - 46px) !important;
    }
  }
  @media (max-width: 991.98px) {
    html body .navbar {
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }
  .navbar .navbar-brand {
    margin-left: 0;
    margin-top: 14px;
  }

  /* ---------- Botón de colapsar/expandir sidebar ---------- */
  /* Círculo minimalista a caballo sobre el borde derecho del sidebar: solo
     contorno fino, sin relleno ni sombra. No se toca "display" (lo sigue
     controlando el show/hide de _responsive.scss según el estado). */
  .sidebar .sidebar-control {
    position: absolute !important;
    /* Centrado a la altura del logo del navbar (que vive fuera del
       sidebar, por encima de él): el logo mide 55px con 15px de margen
       arriba, así que su centro cae en el navbar a 43px del top de la
       ventana; el sidebar empieza a 72px, así que el offset es -41px. Se
       movió el slot "control" fuera de .sidebar-wrapper (que tiene
       overflow:hidden) para que este offset negativo no se recorte. */
    top: -41px !important;
    left: auto !important;
    right: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 24px !important;
    height: 24px !important;
    line-height: 22px !important;
    text-align: center;
    background: #ffffff !important;
    border: 1px solid #b9bec7 !important;
    border-radius: 50% !important;
    box-shadow: none !important;
    z-index: 100;
    transition: border-color 0.15s ease, top 0.15s ease;
  }
  .sidebar .sidebar-control a {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 1 !important;
    color: #6b7280 !important;
    /* El <a> trae la clase de Bootstrap "border-bottom" (1px solid #dee2e6);
       como el enlace es un cuadrado sin recortar a la forma circular del
       botón, esa línea asomaba por las esquinas inferiores del círculo y se
       veía como una sombra debajo. */
    border-bottom: none !important;
  }
  .sidebar .sidebar-control .nav-link i {
    display: block !important;
    color: #6b7280 !important;
    font-size: 4px !important;
    width: 4px !important;
    line-height: 1 !important;
    margin: 0 !important;
  }
  .sidebar .sidebar-control:hover {
    border-color: var(--cd-brand-green, #2E9E4F) !important;
  }
  /* Anula el fondo verde rectangular del hover general de las opciones del
     menú (no está pensado para un botón circular como este). */
  .sidebar .sidebar-control:hover .nav-link {
    background: transparent !important;
  }
  .sidebar .sidebar-control:hover .nav-link i {
    color: var(--cd-brand-green, #2E9E4F) !important;
  }

  /* ---------- Títulos de sección (no interactivos) ---------- */
  .sidebar .sidebar-group-title {
    margin: 8px 20px 6px;
    padding-top: 18px;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #6b7280;
    white-space: nowrap;
    border-top: 1px solid var(--cd-border-light, #e2e5ec);
  }
  .sidebar .nav-main__links > div > .sidebar-group-title:first-child {
    margin-top: 44px;
    padding-top: 0;
    border-top: none;
  }
  .sidebar-group-title__abbr {
    display: none;
  }
  /* Colapsado: título completo -> abreviatura centrada bajo el icono. */
  .nav-reduced .sidebar-group-title,
  .nav-closed-reduced .sidebar-group-title {
    margin: 14px 8px 8px !important;
    padding-top: 10px !important;
    text-align: center;
    border-top: 1px solid var(--cd-border-light, #e2e5ec);
  }
  .nav-reduced .nav-main__links > div > .sidebar-group-title:first-child,
  .nav-closed-reduced .nav-main__links > div > .sidebar-group-title:first-child {
    border-top: none;
    margin-top: 44px !important;
    padding-top: 0 !important;
  }
  .nav-reduced .sidebar-group-title__full,
  .nav-closed-reduced .sidebar-group-title__full {
    display: none;
  }
  .nav-reduced .sidebar-group-title__abbr,
  .nav-closed-reduced .sidebar-group-title__abbr {
    display: block;
  }

  /* ---------- Iconos: más finos, menos "bastos" ---------- */
  .sidebar .nav li .nav-link i {
    font-size: 17px !important;
    width: 24px !important;
    margin-right: 12px !important;
  }

  /* Iconos de las opciones del menú: SVG (Tabler Icons, MIT) incrustados vía
     CSS mask con stroke-width=1, para controlar grosor de línea y tamaño
     (la fuente de iconos no permite ajustar el stroke). Heredan color por
     currentColor igual que el resto (oscuro / verde en hover-activo). */
  .sidebar .nav li .nav-link i.icon-svg {
    display: inline-block;
    width: 23px !important;
    height: 23px;
    margin-right: 12px !important;
    background-color: currentColor;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }
  .icon-svg.icon-home {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M5 12l-2 0l9 -9l9 9l-2 0'/><path d='M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7'/><path d='M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M5 12l-2 0l9 -9l9 9l-2 0'/><path d='M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7'/><path d='M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6'/></svg>");
  }
  .icon-svg.icon-file-text {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M14 3v4a1 1 0 0 0 1 1h4'/><path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2'/><path d='M9 9l1 0'/><path d='M9 13l6 0'/><path d='M9 17l6 0'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M14 3v4a1 1 0 0 0 1 1h4'/><path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2'/><path d='M9 9l1 0'/><path d='M9 13l6 0'/><path d='M9 17l6 0'/></svg>");
  }
  .icon-svg.icon-clock {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0'/><path d='M12 7v5l3 3'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0'/><path d='M12 7v5l3 3'/></svg>");
  }
  .icon-svg.icon-building {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M3 21l18 0'/><path d='M9 8l1 0'/><path d='M9 12l1 0'/><path d='M9 16l1 0'/><path d='M14 8l1 0'/><path d='M14 12l1 0'/><path d='M14 16l1 0'/><path d='M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M3 21l18 0'/><path d='M9 8l1 0'/><path d='M9 12l1 0'/><path d='M9 16l1 0'/><path d='M14 8l1 0'/><path d='M14 12l1 0'/><path d='M14 16l1 0'/><path d='M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16'/></svg>");
  }
  .icon-svg.icon-calendar {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12'/><path d='M16 3v4'/><path d='M8 3v4'/><path d='M4 11h16'/><path d='M11 15h1'/><path d='M12 15v3'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12'/><path d='M16 3v4'/><path d='M8 3v4'/><path d='M4 11h16'/><path d='M11 15h1'/><path d='M12 15v3'/></svg>");
  }
  .icon-svg.icon-user {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0'/><path d='M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0'/><path d='M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2'/></svg>");
  }
  .icon-svg.icon-clipboard-list {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2'/><path d='M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2'/><path d='M9 12l.01 0'/><path d='M13 12l2 0'/><path d='M9 16l.01 0'/><path d='M13 16l2 0'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2'/><path d='M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2'/><path d='M9 12l.01 0'/><path d='M13 12l2 0'/><path d='M9 16l.01 0'/><path d='M13 16l2 0'/></svg>");
  }
  .icon-svg.icon-tag {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M6.5 7.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0'/><path d='M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M6.5 7.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0'/><path d='M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3'/></svg>");
  }
  .icon-svg.icon-folder {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1' stroke-linecap='round' stroke-linejoin='round'><path d='M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2'/></svg>");
  }
  /* Iconos de acciones de fila en listados (editar/eliminar): mismos que
     usa tabler.io "edit" y "trash-x", homogeneizados en toda la app. */
  .icon-svg.icon-edit {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1'/><path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z'/><path d='M16 5l3 3'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1'/><path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z'/><path d='M16 5l3 3'/></svg>");
  }
  .icon-svg.icon-trash {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M4 7l16 0'/><path d='M10 11l4 4m0 -4l-4 4'/><path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12'/><path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M4 7l16 0'/><path d='M10 11l4 4m0 -4l-4 4'/><path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12'/><path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3'/></svg>");
  }
  /* Icono "+" de los botones Nuevo/Agregar (tabler.io "plus"). */
  .icon-svg.icon-plus {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M12 5l0 14'/><path d='M5 12l14 0'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M12 5l0 14'/><path d='M5 12l14 0'/></svg>");
  }
  /* Icono de "arrastrar para reordenar" (tabler.io "grip-vertical"), usado
     en la lista de elementos de Plantillas de solicitud. */
  .icon-svg.icon-grip-vertical {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='black' stroke='none'><circle cx='9' cy='5' r='1.5'/><circle cx='9' cy='12' r='1.5'/><circle cx='9' cy='19' r='1.5'/><circle cx='15' cy='5' r='1.5'/><circle cx='15' cy='12' r='1.5'/><circle cx='15' cy='19' r='1.5'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='black' stroke='none'><circle cx='9' cy='5' r='1.5'/><circle cx='9' cy='12' r='1.5'/><circle cx='9' cy='19' r='1.5'/><circle cx='15' cy='5' r='1.5'/><circle cx='15' cy='12' r='1.5'/><circle cx='15' cy='19' r='1.5'/></svg>");
  }
  /* Icono del badge "Vinculado" en Solicitudes pendientes (tabler.io
     "circle-check"). */
  .icon-svg.icon-circle-check {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M9 12l2 2l4 -4'/><path d='M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M9 12l2 2l4 -4'/><path d='M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z'/></svg>");
  }
  /* Iconos de acciones de fila para "Documentos" del rol contacto:
     visualizar (tabler "eye-check") y descargar (tabler "cloud-download"). */
  .icon-svg.icon-eye-check {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M12 17c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6'/><path d='M11.998 11.999m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0'/><path d='M15 19l2 2l4 -4'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M12 17c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6'/><path d='M11.998 11.999m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0'/><path d='M15 19l2 2l4 -4'/></svg>");
  }
  .icon-svg.icon-cloud-download {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4'/><path d='M9 15l3 3l3 -3'/><path d='M12 12l0 6'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4'/><path d='M9 15l3 3l3 -3'/><path d='M12 12l0 6'/></svg>");
  }
  /* Botones de exportar/imprimir (Solicitudes pendientes, Documentos del
     rol contacto): tabler.io "file-excel", "file-type-pdf" y "printer". */
  .icon-svg.icon-file-excel {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M14 3v4a1 1 0 0 0 1 1h4'/><path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z'/><path d='M8 11l4 6'/><path d='M8 17l4 -6'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M14 3v4a1 1 0 0 0 1 1h4'/><path d='M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z'/><path d='M8 11l4 6'/><path d='M8 17l4 -6'/></svg>");
  }
  .icon-svg.icon-file-pdf {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M14 3v4a1 1 0 0 0 1 1h4'/><path d='M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4'/><path d='M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6'/><path d='M11 18h1a2 2 0 0 0 0 -4h-1v6h1a2 2 0 0 0 0 -4z'/><path d='M17.5 21v-6h2.5m-2.5 3h2'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M14 3v4a1 1 0 0 0 1 1h4'/><path d='M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4'/><path d='M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6'/><path d='M11 18h1a2 2 0 0 0 0 -4h-1v6h1a2 2 0 0 0 0 -4z'/><path d='M17.5 21v-6h2.5m-2.5 3h2'/></svg>");
  }
  .icon-svg.icon-printer {
    -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2'/><path d='M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4'/><path d='M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z'/></svg>");
    mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2'/><path d='M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4'/><path d='M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z'/></svg>");
  }

  /* ---------- Padding horizontal de la zona de contenido (todas las vistas) ---------- */
  .main-panel .content {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  /* La mayoría de vistas ya usan el patrón Bootstrap
     ".container-fluid > .row > .col-*", que por sí solo ya deja el
     contenido a 15px del borde (el padding de .container-fluid + el
     padding de la columna, cancelado en parte por el margen negativo de
     .row). Sin esto, el nuevo padding de .content se sumaría y quedarían
     a 30px. En vez de compensar con márgenes negativos (poco fiable: con
     "width" fijo y margin-right negativo el navegador puede ignorarlo por
     quedar "sobre-restringido"), se anula directamente el padding/margen
     nativo de ese primer nivel, dejando el padding de .content como única
     fuente del espaciado. */
  .main-panel .content > .container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .main-panel .content > .container-fluid > .row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .main-panel .content > .container-fluid > .row > [class*="col-"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  /* En tablet/móvil el sidebar colapsado ya deja poco espacio (72px), así
     que todo se pega al borde izquierdo: sin padding-left, solo se
     mantiene el padding-right. */
  @media (max-width: 991.98px) {
    html body .main-panel .content {
      padding-left: 0 !important;
      padding-right: 15px !important;
    }
  }

  /* ---------- Modo colapsado: riel con iconos centrados ---------- */
  .nav-reduced .sidebar,
  body > .nav-reduced .navbar-collapse,
  .nav-closed-reduced .sidebar,
  body > .nav-closed-reduced .navbar-collapse {
    width: 72px !important;
  }
  .nav-reduced .main-panel .content,
  .nav-closed-reduced .main-panel .content {
    margin-left: 72px !important;
  }
  .nav-reduced .sidebar .nav li .nav-link,
  .nav-closed-reduced .sidebar .nav li .nav-link {
    display: flex !important;
    justify-content: center !important;
    margin: 4px 8px !important;
    padding: 10px 0 !important;
  }
  /* Selector con la misma forma que la regla base de iconos (.sidebar .nav
     li .nav-link i) para poder ganarle en especificidad y centrar de verdad. */
  .nav-reduced .sidebar .nav li .nav-link i,
  .nav-closed-reduced .sidebar .nav li .nav-link i {
    margin: 0 !important;
    width: auto !important;
    float: none !important;
  }
  .nav-reduced .sidebar .nav li .nav-link i.icon-svg,
  .nav-closed-reduced .sidebar .nav li .nav-link i.icon-svg {
    width: 23px !important;
    margin: 0 !important;
  }
  .nav-reduced .sidebar .nav li .nav-link p,
  .nav-closed-reduced .sidebar .nav li .nav-link p {
    display: none !important;
  }
  /* El riel colapsado (72px) es más estrecho que el logo (termina en
     145px), así que anclado al borde derecho del sidebar (right:0) el
     punto quedaría encima del texto "CleverDocs". Se ancla en su lugar a
     una posición fija justo a la derecha del logo, a su misma altura. */
  .nav-reduced .sidebar .sidebar-control,
  .nav-closed-reduced .sidebar .sidebar-control {
    right: auto !important;
    left: 155px !important;
  }

  /* ---------- Links de primer nivel y submenús ---------- */
  .sidebar .nav .nav-link,
  body > .navbar-collapse .nav .nav-link {
    border-bottom: none !important;
    color: #3a3f4b !important;
    text-transform: none !important;
    font-weight: 500;
  }
  .sidebar .nav li .nav-link i,
  body > .navbar-collapse .nav li .nav-link i {
    color: #3a3f4b;
  }
  .sidebar .nav li:hover .nav-link,
  body > .navbar-collapse .nav li:hover .nav-link {
    background: var(--cd-brand-green-light, #6bc47d) !important;
    background: rgba(46, 158, 79, 0.1) !important;
    color: var(--cd-brand-green, #2E9E4F) !important;
    opacity: 1;
  }
  .sidebar .nav li:hover .nav-link i,
  body > .navbar-collapse .nav li:hover .nav-link i {
    color: var(--cd-brand-green, #2E9E4F);
  }
  .sidebar .nav li.active > .nav-link,
  .sidebar .nav li.active .nav-link {
    background: rgba(46, 158, 79, 0.14) !important;
    color: var(--cd-brand-green, #2E9E4F) !important;
    box-shadow: inset 3px 0 0 var(--cd-brand-green, #2E9E4F);
  }
  .sidebar .nav li.active > .nav-link i,
  .sidebar .nav li.active .nav-link i {
    color: var(--cd-brand-green, #2E9E4F);
  }

  /* Submenús desplegables (segundo nivel) */
  div.sidebar > div > ul.nav.nav-main__links > div > li > div > ul {
    background: #fafbfc;
  }
  div.sidebar > div > ul.nav.nav-main__links > div > li > div > ul > li > a {
    color: #4a4f5c !important;
  }
  div.sidebar > div > ul.nav.nav-main__links > div > li > div > ul > li > a:hover {
    background: rgba(46, 158, 79, 0.1) !important;
    color: var(--cd-brand-green, #2E9E4F) !important;
  }
  div.sidebar > div > ul.nav.nav-main__links div li > a:hover {
    background: rgba(46, 158, 79, 0.1) !important;
  }
  div.sidebar > div > ul.nav.nav-main__links div li > a {
    background: transparent !important;
  }

  /* ---------- Tablet / móvil: mismo aspecto colapsado que escritorio ---------- */
  /* No es un diseño nuevo: son las mismas reglas que el modo "reducido" de
     escritorio, aplicadas también por debajo de 992px, sin depender del
     botón de hamburguesa (que sigue funcionando igual que antes para el
     resto de la app, simplemente aquí no hace falta usarlo). */
  @media (max-width: 991.98px) {
    /* "html body" para ganar en especificidad de forma segura al mixin de
       _vendor-prefixes.scss, que aplica "transform: ... !important" sobre
       ".sidebar" a secas; con la misma especificidad y !important en ambos
       lados, quien gane depende del orden de inyección de estilos, que con
       Vue no es fiable. */
    html body .sidebar {
      display: block !important;
      transform: none !important;
      width: 72px !important;
      position: fixed !important;
      left: 0 !important;
      right: auto !important;
      top: 56px !important;
      bottom: 0 !important;
      overflow: hidden !important;
    }
    /* El wrapper interno hereda 260px del estado "abierto" por defecto;
       si no se fuerza también aquí, se desborda por encima del contenido. */
    html body .sidebar .sidebar-wrapper {
      width: 72px !important;
      /* El navbar de escritorio mide 72px (logo 55px + margen) pero el de
         tablet/móvil solo 56px, así que el sidebar arranca 16px más arriba
         aquí. Se suman esos 16px al padding-top base (20px) para que
         "Inicio" quede a la misma altura absoluta que en escritorio. */
      padding-top: 18px !important;
    }
    html body .sidebar .logo {
      display: none !important;
    }
    html body .sidebar .sidebar-control {
      display: none !important;
    }
    /* El menú de usuario (dentro de .navbar-collapse) es un .collapse de
       Bootstrap, oculto por defecto por debajo de "lg" salvo que algo le
       añada la clase .show — cosa que aquí nunca ocurre. Se fuerza visible. */
    html body .navbar .navbar-collapse {
      display: flex !important;
      align-items: center !important;
    }
    /* Sin esto, el navbar envuelve en dos líneas por debajo de "lg" y el
       menú de usuario cae por debajo del logo en vez de quedar a su altura,
       tapando el contenido de debajo. */
    html body .navbar .container-fluid {
      display: flex !important;
      flex-wrap: nowrap !important;
      align-items: center !important;
    }
    /* Bootstrap pone .navbar-nav en flex-direction:column por debajo de
       "lg" por defecto (solo pasa a fila con .navbar-expand-lg a partir de
       ese punto). Aquí apilaba el icono de contacto y el de usuario uno
       encima del otro, haciendo el navbar mucho más alto de lo esperado y
       tapando el título de la primera sección del sidebar. */
    html body .navbar .navbar-nav {
      flex-direction: row !important;
    }
    html body .navbar .navbar-brand {
      margin-top: 0 !important;
    }
    html body .main-panel .content {
      margin-left: 72px !important;
    }
    html body .sidebar .nav li .nav-link {
      display: flex !important;
      justify-content: center !important;
      margin: 4px 8px !important;
      padding: 10px 0 !important;
      width: auto !important;
      white-space: normal !important;
    }
    html body .sidebar .nav li .nav-link i {
      margin: 0 !important;
      width: auto !important;
      float: none !important;
    }
    html body .sidebar .nav li .nav-link i.icon-svg {
      width: 23px !important;
      margin: 0 !important;
    }
    html body .sidebar .nav li .nav-link p {
      display: none !important;
    }
    html body .sidebar-group-title__full {
      display: none !important;
    }
    html body .sidebar-group-title__abbr {
      display: block !important;
    }
    html body .sidebar .sidebar-group-title {
      margin: 14px 8px 8px !important;
      padding-top: 10px !important;
      text-align: center;
      border-top: 1px solid var(--cd-border-light, #e2e5ec);
    }
    html body .sidebar .nav-main__links > div > .sidebar-group-title:first-child {
      border-top: none !important;
      margin-top: 44px !important;
      padding-top: 0 !important;
    }
  }

  /* ---------- Pie del sidebar: info de la app ---------- */
  .sidebar-footer {
    margin-top: auto;
    padding: 14px 20px 24px;
    border-top: 1px solid var(--cd-border-light, #e2e5ec);
  }
  .sidebar-footer__title {
    margin: 0 0 6px;
    font-size: 11px;
    font-weight: 700;
    color: #6b7280;
  }
  /* El título del pie es un enlace a la web de la compañía. Hereda el gris y la
     negrita del pie en vez del azul de Bootstrap: sigue leyéndose como parte de la
     información, y solo al pasar por encima se anuncia como enlace.

     El font-weight no sobra: la tipografía global de light-bootstrap nombra "a" en
     una regla propia ("body, h1, ..., p, ..., a, ... { font-weight: 400 }"), y una
     regla directa sobre el enlace gana a lo que herede del <p>, así que el título
     perdía la negrita al envolverlo. Con inherit vuelve a seguir al título, y le
     seguirá si algún día cambia de peso. */
  .sidebar-footer__title a {
    color: inherit;
    font-weight: inherit;
    text-decoration: none;
  }
  .sidebar-footer__title a:hover,
  .sidebar-footer__title a:focus {
    color: var(--cd-brand-green, #43a047);
    text-decoration: underline;
  }
  .sidebar-footer__line {
    margin: 0;
    font-size: 11px;
    line-height: 1.6;
    color: #6b7280;
  }
  /* Versión compacta (solo tablet/móvil): mismas características visuales
     (colores, línea de separación) pero con el texto abreviado para que
     quepa en el riel de 72px. */
  .sidebar-footer--compact {
    display: none;
    text-align: center;
    padding: 14px 8px 20px;
  }
  /* No cabe en el riel colapsado de escritorio: se sustituye por la misma
     versión compacta que se usa en tablet/móvil. */
  .nav-reduced .sidebar-footer--full,
  .nav-closed-reduced .sidebar-footer--full {
    display: none !important;
  }
  .nav-reduced .sidebar-footer--compact,
  .nav-closed-reduced .sidebar-footer--compact {
    display: block !important;
  }
  @media (max-width: 991.98px) {
    html body .sidebar-footer--full {
      display: none !important;
    }
    html body .sidebar-footer--compact {
      display: block !important;
    }
  }

  /* ---------- Riel colapsado en escritorio: expandir con el ratón por encima ----------
     Solo de min-width 992px para arriba (en tablet/móvil el sidebar usa el
     mecanismo de "expandir con un toque" de más abajo, no el hover: un
     dispositivo táctil no tiene un verdadero "ratón encima", y algunos
     navegadores móviles simulan :hover en el primer toque, lo que producía
     una expansión no deseada). Solo cuando el sidebar está colapsado
     ("reduced"/"closed_reduced"), nunca cuando el usuario lo ha fijado
     abierto con el botón ("opened"/"closed"), ya que esos estados no llevan
     estas clases. Es un flyout: el sidebar se superpone visualmente sobre
     el contenido (position:fixed + z-index), sin empujarlo, porque el
     margin-left de .content sigue fijo en 72px. */
  @media (min-width: 992px) {
    .nav-reduced .sidebar,
    .nav-closed-reduced .sidebar {
      transition: width .18s ease;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover),
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) {
      width: 260px !important;
      /* Por debajo del stack de modales (Bootstrap usa 1040/1050, el propio
         Modal.vue 500): solo tiene que quedar por encima del contenido de
         la página (navbar/tarjetas rondan 99-100), nunca por encima de un
         velo o un modal abierto. */
      z-index: 200;
      /* !important porque la regla base del sidebar apaga la sombra con
         "box-shadow: none !important" (arriba, junto a body > .navbar-collapse), y
         una declaración normal no puede ganarle por mucha especificidad que tenga:
         sin esto el flyout salía sin sombra sobre el contenido.

         La sombra cae a la derecha y nada por arriba: el desplazamiento vertical
         (4px) más el spread negativo (-8px) mantienen el difuminado del blur (24px)
         justo por debajo del borde superior, que si no manchaba el navbar. */
      box-shadow: 10px 4px 24px -8px rgba(0, 0, 0, 0.22) !important;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .nav li .nav-link,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .nav li .nav-link {
      justify-content: flex-start !important;
      padding: 10px 16px !important;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .nav li .nav-link i.icon-svg,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .nav li .nav-link i.icon-svg {
      margin-right: 12px !important;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .nav li .nav-link p,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .nav li .nav-link p {
      display: block !important;
      /* La plantilla base trae "font-size: 0" en este <p> (técnica antigua
         para ocultar el texto en el sidebar colapsado); sin restaurarlo aquí
         el texto queda con ancho 0 y no se ve aunque display ya no sea none. */
      font-size: 12px !important;
      line-height: normal !important;
      /* MAYÚSCULAS y 600: así es como se ve este mismo <p> en el sidebar
         fijado abierto ("opened"), por la regla base .sidebar .nav-item
         .nav-link p (más específica que el .sidebar .nav .nav-link de más
         arriba, que solo toca el <a> y no llega a heredarse hasta aquí). */
      text-transform: uppercase !important;
      font-weight: 600 !important;
      white-space: nowrap;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-group-title,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-group-title {
      text-align: left;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-group-title__full,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-group-title__full {
      display: block !important;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-group-title__abbr,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-group-title__abbr {
      display: none !important;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-footer--full,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-footer--full {
      display: block !important;
    }
    .nav-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-footer--compact,
    .nav-closed-reduced .sidebar:hover:not(.sidebar--suppress-hover) .sidebar-footer--compact {
      display: none !important;
    }
    /* OJO: el puntito de colapsar/expandir NO se reposiciona aquí a
       propósito. Si su posición cambiara en función de si el sidebar está
       en hover (p.ej. saltando de left:155px a right:0), en el instante en
       que el ratón está justo encima del puntito este se movería por debajo
       del cursor, generando un mouseleave -> el sidebar se colapsa -> el
       puntito vuelve a su sitio -> el cursor vuelve a estar encima -> se
       expande de nuevo... un parpadeo infinito. Se queda anclado siempre en
       su posición del riel de 72px (sigue cabiendo perfectamente dentro del
       sidebar expandido a 260px). */
  }

  /* ---------- Riel colapsado en tablet/móvil: expandir con un toque ----------
     Aquí el sidebar SIEMPRE es el riel de 72px (ver "html body .sidebar" más
     arriba, independiente del estado reduced/opened/etc.), así que no hace
     falta condicionar por esas clases. El toggle lo controla SideBar.vue: un
     toque en zona vacía del sidebar alterna esta clase; un toque en una
     opción, o fuera del sidebar, la quita. "html body" iguala la
     especificidad de la regla que fija los 72px para poder ganarle. */
  @media (max-width: 991.98px) {
    html body .sidebar.sidebar--mobile-expanded {
      width: 260px !important;
      /* Por debajo del stack de modales (Bootstrap usa 1040/1050, el propio
         Modal.vue 500): solo tiene que quedar por encima del contenido de
         la página (navbar/tarjetas rondan 99-100), nunca por encima de un
         velo o un modal abierto. */
      z-index: 200;
      /* Mismo caso que el flyout de escritorio: !important para pasar por encima del
         "box-shadow: none !important" de la regla base, y la misma sombra, que cae a
         la derecha sin asomar por el borde de arriba. */
      box-shadow: 10px 4px 24px -8px rgba(0, 0, 0, 0.22) !important;
      transition: width .18s ease;
    }
    html body .sidebar.sidebar--mobile-expanded .sidebar-wrapper {
      width: 260px !important;
    }
    html body .sidebar.sidebar--mobile-expanded .nav li .nav-link {
      justify-content: flex-start !important;
      padding: 10px 16px !important;
      white-space: nowrap !important;
    }
    html body .sidebar.sidebar--mobile-expanded .nav li .nav-link i.icon-svg {
      margin-right: 12px !important;
    }
    html body .sidebar.sidebar--mobile-expanded .nav li .nav-link p {
      display: block !important;
      font-size: 12px !important;
      line-height: normal !important;
      /* Igual que en el hover de escritorio: mayúsculas y 600 es como se ve
         este mismo <p> en el sidebar abierto (regla base .sidebar .nav-item
         .nav-link p, más específica que la que solo toca el <a>). */
      text-transform: uppercase !important;
      font-weight: 600 !important;
      white-space: nowrap;
    }
    html body .sidebar.sidebar--mobile-expanded .sidebar-group-title {
      text-align: left;
    }
    html body .sidebar.sidebar--mobile-expanded .sidebar-group-title__full {
      display: block !important;
    }
    html body .sidebar.sidebar--mobile-expanded .sidebar-group-title__abbr {
      display: none !important;
    }
  }
</style>
